import React from "react";
import { useFieldArray } from "react-hook-form";

const FieldArrayHook = ({ control, name, children }) => {
  const { fields, append, remove, prepend } = useFieldArray({ name, control });

  return children({ fields, append, remove, prepend });
};

export default FieldArrayHook;